import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {Amplify} from "aws-amplify";
import {Authenticator} from "@aws-amplify/ui-react";
import {App} from "./App";
import {auth_config} from "./config/auth_config";
import {ColorModeProvider} from "./theme/ColorModeContext";

// Configure before anything renders. Most of the app is now reachable signed
// out, so this can no longer ride on the AccessController module being imported.
Amplify.configure(auth_config);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ColorModeProvider>
      {/* Guest-visible pages sit outside the Authenticator but still read auth
          state via useAuthenticator, so the provider has to live up here. */}
      <Authenticator.Provider>
        <App />
      </Authenticator.Provider>
    </ColorModeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
